import { useTranslation } from "react-i18next"

const EmptyResult = () => {
    const { t } = useTranslation();
    return (
        <div className="w-100 py-3 text-center">
            <h4>{t('messNoResult')}</h4>
        </div>
    )
}

export default EmptyResult;